@if (settings.showJewelleryTierListMessage()) {
  <div class="info box reset-font" style="margin-bottom: 12px;">
    <div class="close-info-btn" (click)="hideInfoMessage()">✕</div>
    <h3 class="info-title">Explainer: <strong>Jewellery Tier List</strong></h3>

    <div class="info-box-body">
      <app-content cid="explainer-jewellery-tier-list" contentType="tip" [conditions]="{ poe1: poe1, poe2: poe2 }"></app-content>
      <p><a class="remove-warning-link" (click)="hideInfoMessage()">(I understand, dismiss)</a></p>
    </div>
  </div>
}

<div class="tier-list-info">
  <div class="tier-input">
    <span>
      <span>Jewellery Class</span>
      <app-select class="inline" [searchable]="true" [alignLeft]="true" style="width: 200px" [disabled]="false" [(ngModel)]="jewelleryClass" (selectedValueChange)="changeJewelleryClass()">
        @for (jewelleryClassOption of jewelleryClassList; track jewelleryClassOption.type) {
          <app-option [value]="jewelleryClassOption.type" [text]="jewelleryClassOption.type" [imgUrl]="jewelleryClassOption.image ? imgPrefix + jewelleryClassOption.image : ''" [alt]="jewelleryClassOption.type" [width]="'16px'" [height]="'16px'">
          </app-option>
        }
      </app-select>
    </span>
  </div>
</div>

<div class="tier-list-container">
  @if (selectedJewelleryTierDataVm) {
  <div class="tier-list">
    @for (tier of selectedJewelleryTierDataVm; track tier.tier) {
    <div class="tier"
         (dragenter)="onDragEnter($event, tier)"
         (dragover)="onDragOver($event)"
         (dragleave)="onDragLeave($event, tier)"
         (drop)="onDrop($event, tier)"
         [class.drag-over]="tier.isDragOver">
      <div class="tier-title {{ tier.tierStyle }}">
        <h3>{{ tier.tier }} <app-jewellery-tier-icon [tier]="tier.tier"></app-jewellery-tier-icon></h3>
      </div>
      @if (tier.tierSubtitle) {
        <div class="tier-subtitle">{{ tier.tierSubtitle }}</div>
      }
      @if (jewelleryClass === JewelleryType.All && tier.itemTypes) {
        <div class="tier-item-types normal-item-color">
          @for (itemType of tier.itemTypes; track itemType.itemType) {
            <div class="tier-item-type">
              <div class="tier-item-type-title"><h4>{{ itemType.itemType }}</h4></div>
              <div class="tier-item-type-body">
                @for (item of itemType.items; track item.name) {
                  <ng-container *ngTemplateOutlet="jewelleryItem; context: { $implicit: item, tier: tier }"></ng-container>
                }
              </div>
            </div>
          }
        </div>
      } @else if (tier.items) {
        <div class="tier-item-types normal-item-color">
          @for (item of tier.items; track item.name) {
            <ng-container *ngTemplateOutlet="jewelleryItem; context: { $implicit: item, tier: tier }"></ng-container>
          }
        </div>
      }
    </div>
    }
  </div>
  }
</div>

<ng-template #jewelleryItem let-item let-tier="tier">
  <div class="tier-item-type-base-type">
    <app-item-label
      [class.rare-item-color]="item.isRareOnly"
      [jewellery]="true"
      [enableJewelleryTierNavigation]="false"
      [baseType]="item.name"
      [image]="item.image"
      [restricted]="item.restricted"
      [restrictedContent]="item.restrictedContent"
      [hideTooltip]="draggedItem?.name == item.name"
      draggable="true"
      (dragstart)="onDragStart($event, item)"
      (dragend)="onDragEnd()"
      [class.dragged]="draggedItem?.name === item.name"></app-item-label>
    @if (item.originalTier && item.originalTier !== tier.tier) {
      <span class="original-tier" (click)="resetToOriginalTier(item)"
            title="Reset to original {{ item.originalTier }}-tier">↻</span>
    }
  </div>
</ng-template>
